module.exports = __webpack_public_path__ + "static/the-brief-wondrous-life-of-oscar-wao-9378c04191844dc6f17ea6a5fe806360.jpg";